import { updateObject } from '../libs/utils'

const app = (state = {
  toastActive: false,
  toastMessage: null,
  toastError: true,
  app: {},
  activeItem: {},
  activePin: null
}, action) => {
  const pins = state.activeItem.pins

  switch (action.type) {
    case 'SET_APP_DATA':
      return {
        ...state,
        app: action.data
      }
    case 'SET_SELECTED_ITEM':
      return {
        ...state,
        activeItem: action.item
      }
    case 'UPDATE_FIELD':
      if (state.activeItem.hasOwnProperty(action.key)) {
        const updatedField = {}
        if (action.value instanceof Array) {
          updatedField[action.key] = [...action.value]
        } else {
          updatedField[action.key] = action.value
        }
        const updatedActiveItem = updateObject(state.activeItem, updatedField)
        return {
          ...state,
          activeItem: updatedActiveItem
        }
      }
      return state
    case 'ACTIVE_PIN':
      return {
        ...state,
        activePin: action.index
      }
    case 'UPDATE_PIN_FIELD':
      const clonedPins = [...pins]
      const { key, value, index } = action
      const pinIndex = index || state.activePin
      const activePin = {...clonedPins[pinIndex]}
      if (activePin) {
        activePin[key] = value
        const updatedPins = clonedPins.filter(pin => typeof pin === 'object').map((pin, i) => (
          i === pinIndex ? activePin  : pin
        ))
        return {
          ...state,
          activeItem: {
            ...state.activeItem,
            pins: updatedPins
          }
        }
      }
      return state
    case 'ADD_NEW_PIN':
      return {
        ...state,
        activeItem: {
          ...state.activeItem,
          pins: state.activeItem.pins.concat([action.pinData])
        }
      }
    case 'DELETE_PIN':
      const deletedPins = pins.filter((pin, index) => index !== state.activePin)
      return {
        ...state,
        activeItem: updateObject(state.activeItem, { pins: deletedPins })
      }
    case 'DUPLICATE_PIN':
      return {
        ...state,
        activeItem: {
          ...state.activeItem,
          pins: state.activeItem.pins.concat([action.pin])
        }
      }
    case 'TOGGLE_TOAST_ACTIVE':
      return {
        ...state,
        toastActive: action.value
      }
    case 'SET_TOAST_MESSAGE':
      return {
        ...state,
        toastError: true, // reset toast error is true
        toastMessage: action.value
      }
    case 'SET_TOAST_ERROR':
      return {
        ...state,
        toastError: action.value
      }
    default:
      return state
  }
}

export default app
